import { type Module } from "vuex";
import type { DefaultApi, CompanyAnalysisRequest } from "@/api";
import { CompanyAnalysis } from "@/models/company_analysis";
import type { State as RootState } from "@/stores";
export interface State {}
export const module: Module<State, RootState> = {
  namespaced: true,
  actions: {
    async getCompanyAnalysis({}, companyAnalysisId: number) {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const response = await api.getCompanyAnalysis(companyAnalysisId);
      return new CompanyAnalysis(response.data);
    },
    async postCompanyAnalysis(
      {},
      companyAnalysisRequest: CompanyAnalysisRequest,
    ) {
      const api: DefaultApi = await this.dispatch("getAuthorizedApi", null, {
        root: true,
      });
      const response = await api.postCompanyAnalysis(companyAnalysisRequest);
      return new CompanyAnalysis(response.data);
    },
  },
};
